export default "__VITE_ASSET__BOeJZvyx__";